/**
 * Cookie de sesion de GA4 que viaja al checkout de Stripe (VEX-7051).
 *
 * El `purchase` de Stripe lo manda el backend por Measurement Protocol, y sin
 * `session_id` GA4 no lo une a la sesion del navegador: llega con origen/medio
 * `(not set)`. El id de sesion vive en la cookie `_ga_<id del flujo>`.
 *
 * Tiene que ser la del flujo G-DTVMVMNNFE, el mismo al que manda el backend
 * (ENV_GA4_MEASUREMENT_ID): la sesion de otro flujo no une con nada. Por eso el
 * nombre va fijo y no se busca "la primera `_ga_*`" (ver VEX-6457, dos flujos
 * midiendo el sitio a la vez).
 *
 * Se manda la cookie CRUDA, como `_ga`: el formato cambio de GS1 a GS2 y el
 * recorte lo hace el backend (Ga4MeasurementProtocol::normalizeSessionId).
 */
export const GA4_SESSION_COOKIE = '_ga_DTVMVMNNFE';

export const gaSessionCookie = (cookies) =>
  (cookies && cookies.get(GA4_SESSION_COOKIE)) || undefined;

/**
 * Los mismos dos datos, ya recortados, para el `custom` de PayPal (VEX-7058).
 *
 * Ahi no se puede mandar crudo: `custom` tiene un tope de 256 caracteres y el
 * de un pago unico ya promedia 248. La cookie de sesion cruda son ~45; el id,
 * 10. Los recortes son los mismos que hace el backend
 * (Ga4MeasurementProtocol::normalizeClientId / normalizeSessionId), que acepta
 * las dos formas.
 */
export const gaClientId = (cookies) => {
  const raw = cookies && cookies.get('_ga');
  const match = typeof raw === 'string' && raw.match(/^GA\d+\.\d+\.(\d{1,20}\.\d{1,20})$/);
  return match ? match[1] : undefined;
};

export const gaSessionId = (cookies) => {
  const raw = gaSessionCookie(cookies);
  if (typeof raw !== 'string') return undefined;
  const match = raw.match(/^GS1\.\d+\.(\d{1,20})\./) || raw.match(/^GS2\.\d+\.s(\d{1,20})(\$|$)/);
  return match ? match[1] : undefined;
};

export default gaSessionCookie;
